export default __webpack_public_path__ + "static/media/radiesse.d5619932.pdf";